/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import Authorization from "../../../../../component/Authorization";
import { Action, ActionType } from "../../../customer/entity/customer.model";
import { Product } from "../../../product/entity/product.model";
import { PromotionProductUI } from "../../entity/promotion-product.model";
import { PromotionProductType } from "../../entity/promotion.model";

export interface PromotionProductTableProps {
  promotionProducts: PromotionProductUI[];
  onEdit?: (promotionProduct: PromotionProductUI) => void;
  onDelete?: (promotionProduct: PromotionProductUI) => void;
  type: PromotionProductType;
}

function PromotionProductTable(props: PromotionProductTableProps) {
  const promotionProductTableColumns: ColumnsType<PromotionProductUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Бүтээгдэхүүн",
      dataIndex: "product",
      key: "product",
      render: (product: Product) => product?.name,
    },
    {
      title: "Тоо",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Хямдрал",
      dataIndex: "sale",
      key: "sale",
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], _record: PromotionProductUI) => (
        <Authorization roles={["promotion-full"]}>
          <div className="list-icons">
            <div className="dropdown">
              <a href="#" className="list-icons-item" data-toggle="dropdown">
                <i className="icon-menu9"></i>
              </a>

              <div className="dropdown-menu dropdown-menu-right">
                {actions.map((action: Action) => {
                  return (
                    <a
                      key={`action-${action.icon}`}
                      href="#"
                      className="dropdown-item"
                      onClick={() => {
                        if (action.type === ActionType.edit) {
                          props.onEdit && props.onEdit(_record);
                        } else if (action.type === ActionType.delete) {
                          Modal.confirm({
                            title: "Баталгаажуулах",
                            content: `Та устгахдаа итгэлтэй байна уу?`,
                            okText: "Үргэлжлүүлэх",
                            cancelText: "Хаах",
                            onOk: () => {
                              props.onDelete && props.onDelete(_record);
                            },
                          });
                        }
                      }}
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </Authorization>
      ),
    },
  ];

  const promotionProductUIs: PromotionProductUI[] = props.promotionProducts.map(
    (promotionProduct, index) => {
      const actions: Action[] = [
        {
          icon: "icon-pencil3",
          text: "Дэлгэрэнгүй",
          type: ActionType.edit,
        },
        {
          icon: "icon-bin2",
          text: "Устгах",
          type: ActionType.delete,
        },
      ];

      return {
        ...promotionProduct,
        actions: actions,
        index: index + 1,
        key: index,
      };
    }
  );

  return (
    <Table
      className="table table-responsive"
      columns={promotionProductTableColumns.filter((x) => {
        if (props.type === PromotionProductType.CONDITION_PRODUCT) {
          return x.key !== "count" && x.key !== "sale";
        } else {
          return x.key !== "sale";
        }
      })}
      dataSource={promotionProductUIs}
      pagination={false}
    />
  );
}
export default PromotionProductTable;
